import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'

export default {
  install(Vue) {
    Vue.use(VueAwesomeSwiper)
  },
}
